export default __webpack_public_path__ + "static/media/team1.dd83d54e.png";